import '@css/app.scss';

import { initSiteScripts } from './components/SiteScripts';
import { initSliders } from './components/Sliders';

if (!import.meta.env.DEV) {
    console.log = () => {};
}

document.addEventListener('DOMContentLoaded', () => {
    initSliders();
    initSiteScripts();
});
